import { useAtomValue, useSetAtom } from 'jotai';
import { hasExpiredPlanAtom, userPlanAtom } from 'app/atoms';
import { presentPayWallAtom } from 'app/atoms/ui';
import { useNavigation } from '@react-navigation/native';
import type { SpecificNavigationProp } from 'app/types/navigation';
import { useMyActivePlans } from 'app/network/plan';
import { useHasExpired } from './use-has-expired';

export function useIsExpiredWithNavigation(navigation: SpecificNavigationProp, goBackBeforePaywall = false) {
  const hasExpiredPlan = useAtomValue(hasExpiredPlanAtom);
  const userPlans = useAtomValue(userPlanAtom);
  const { data: activePlans } = useMyActivePlans();
  const setModalVisible = useSetAtom(presentPayWallAtom);
  const activePlan = activePlans?.[0] ?? userPlans?.[0];
  const activePlanHasExpired = useHasExpired(activePlan?.expiresAt, hasExpiredPlan);
  const needsSubscription = activePlanHasExpired;

  const authorize = (cb: () => unknown) => {
    if (needsSubscription) {
      if (goBackBeforePaywall) {
        navigation.goBack();
      }
      return setModalVisible(true);
    }
    return cb();
  };

  return authorize;
}

export function useIsExpired(goBackBeforePaywall = false) {
  const navigation = useNavigation<SpecificNavigationProp>();
  return useIsExpiredWithNavigation(navigation, goBackBeforePaywall);
}
